<template>
  <div>
    <v-app-bar app height="90" flat dark color="orange" class="ae-bar">
      <a
        class="ae-logo"
        href="https://alterexploring.com"
        target="_blank"
        rel="noopener"
        title="Alter Tours — alterexploring.com"
      >
        <img :src="logoSrc" alt="Alter Tours" />
      </a>

      <div class="ae-title">
        <h2>Alter Exploring Team</h2>
        <span class="ae-sep">|</span>
        <span class="ae-sub">The Activity Calendar</span>
      </div>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-if="this.$store.state.user.token"
          plain
          x-large
          class="secondary--text"
          :ripple="false"
          text
          :to="'/trips'"
          >ΕΚΔΡΟΜΕΣ
        </v-btn>
        <v-btn
          v-if="this.$store.state.user.token"
          plain
          x-large
          class="secondary--text"
          :ripple="false"
          text
          :to="'/customers'"
          >ΠΕΛΑΤΕΣ
        </v-btn>
        <v-btn
          v-if="this.$store.state.user.token"
          plain
          x-large
          class="secondary--text"
          :ripple="false"
          text
          @click="logout()"
          >ΑΠΟΣΥΝΔΕΣΗ
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "navbar",
  components: {},
  data: () => ({
    logoSrc: require("../assets/logos/alter_tours_logo_new.jpeg"),
    links: [
      { title: "ΠΕΛΑΤΕΣ" },
      // { title: "ΕΚΔΡΟΜΕΣ" },
      // { title: "ΚΑΤΕΥΘΥΝΣΕΙΣ" },
      // { title: "ΠΛΑΝΟ" },
      { title: "ΑΠΟΣΥΝΔΕΣΗ" },
    ],
    drawer: false,
    false: false,
    group: null,
  }),

  watch: {
    group() {
      this.drawer = false;
    },
  },

  methods: {
    ...mapActions("user", ["destroyToken"]),

    logout() {
      this.destroyToken().then(() => {
        this.$router.push("/login").catch(() => {});
      });
    },

    forward(pageToMove) {
      if (pageToMove === "ΑΠΟΣΥΝΔΕΣΗ") {
        this.destroyToken().then(() => {
          this.$router.push("/login").catch(() => {});
        });
      } else if (pageToMove === "ΠΕΛΑΤΕΣ") {
        this.$router.push("/customers").catch(() => {});
      } else if (pageToMove === "ΕΚΔΡΟΜΕΣ") {
        this.$router.push("/trips").catch(() => {});
      } else if (pageToMove === "ΠΛΑΝΟ") {
        this.$router.push("/plans").catch(() => {});
      } else if (pageToMove === "ΚΑΤΕΥΘΥΝΣΕΙΣ") {
        this.$router.push("/majors").catch(() => {});
      }
    },
  },
  computed: {},
};
</script>

<style>
.v-btn--active .v-btn__content {
  color: whitesmoke;
}
.ae-bar .v-toolbar__content {
  position: relative;
}
.ae-logo {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}
.ae-logo img {
  display: block;
  height: 58px;
  width: auto;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);
  transition: transform 0.15s ease;
}
.ae-logo img:hover {
  transform: translateY(-2px);
}
.ae-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: baseline;
  gap: 0.55rem;
  white-space: nowrap;
  pointer-events: none;
}
.ae-title h2 {
  font-size: 1.45rem;
  letter-spacing: 0.02em;
  margin: 0;
}
.ae-title .ae-sep {
  opacity: 0.65;
  font-weight: 300;
  font-size: 1.3rem;
}
.ae-title .ae-sub {
  font-weight: 300;
  font-style: italic;
  font-size: 1.15rem;
  opacity: 0.95;
}
@media (max-width: 860px) {
  .ae-title {
    position: static;
    transform: none;
    margin-left: 14px;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    line-height: 1.2;
  }
  .ae-title h2 { font-size: 1.05rem; }
  .ae-title .ae-sep { display: none; }
  .ae-title .ae-sub { font-size: 0.85rem; }
  .ae-logo img { height: 44px; }
}
</style>